<script setup lang="ts">
import VHeading from '@shared/typography/VHeading/VHeading.vue';
import { type CrmMedewerkersGetMedewerkersVoorContactpaginaAccountmanager } from '@services/crm-public/orval-api/model/crmMedewerkersGetMedewerkersVoorContactpaginaAccountmanager';
import ContactInfoBlock from './ContactInfoBlock.vue';
import ContactAvatar from './ContactAvatar.vue';
import ContactLink from './ContactLink.vue';

const props = defineProps<{
  accountmanager?: CrmMedewerkersGetMedewerkersVoorContactpaginaAccountmanager;
}>();

function getImageUrl(gebruikerId: number | null) {
  return gebruikerId ? `/gebruikerimages/${gebruikerId}.jpg` : '';
}
</script>

<template>
  <div class="grid gap-4 rounded-lg bg-white p-4 shadow-sm sm:grid-cols-2 xl:grid-cols-4">
    <div v-if="props.accountmanager">
      <VHeading class="mb-2" :level="2" appearance="sm">Jouw accountmanager</VHeading>
      <div class="flex gap-3">
        <ContactAvatar
          :image-url="getImageUrl(props.accountmanager.gebruikerId)"
          :name="props.accountmanager.volledigeNaam"
          size="small"
        />
        <div class="min-w-0 flex-1 space-y-0.5 text-sm text-grey-700">
          <p class="font-semibold">{{ props.accountmanager.volledigeNaam }}</p>
          <ContactLink
            v-if="props.accountmanager.email"
            type="email"
            :value="props.accountmanager.email"
          />
          <ContactLink
            v-if="props.accountmanager.telefoonnummer"
            type="phone"
            :value="props.accountmanager.telefoonnummer"
          />
        </div>
      </div>
    </div>

    <ContactInfoBlock title="SUREbusiness B.V.">
      <p>Robonsbosweg 7a</p>
      <p>1816 MK Alkmaar</p>
      <p><a href="tel:0723035900">072 - 30 35 900</a></p>
    </ContactInfoBlock>

    <ContactInfoBlock title="Bankgegevens">
      <div>
        <span class="text-grey-600">ADN Postbusnummer: </span>
        <span class="font-semibold text-grey-900">I094399077030646</span>
      </div>
      <div>
        <span class="text-grey-600">Bankrekening: </span>
        <span class="font-semibold text-grey-900">NL81ABNA0497493187</span>
      </div>
    </ContactInfoBlock>

    <ContactInfoBlock title="Registratiegegevens">
      <div>
        <span class="text-grey-600">KvK-nummer: </span>
        <span class="font-semibold text-grey-900">64217728</span>
      </div>
      <div>
        <span class="text-grey-600">AFM Verguningnummer: </span>
        <span class="font-semibold text-grey-900">12043537</span>
      </div>
      <div>
        <span class="text-grey-600">Kifid aansluitnummer: </span>
        <span class="font-semibold text-grey-900">300.016190</span>
      </div>
      <div>
        <span class="text-grey-600">CBP: </span>
        <span class="font-semibold text-grey-900">m1610033</span>
      </div>
    </ContactInfoBlock>
  </div>
</template>
